export const ActionTypes = {
  LOADING: "UPDATE_MS_LOADING",
  ERROR: "UPDATE_MS_ERROR",
  SUCCESS: "UPDATE_MS_SUCCESS",
};
